module.exports = __webpack_public_path__ + "static/media/6.44e5a7a8.jpg";